export const firebaseConfig = {
  apiKey: "AIzaSyBLsZmecJHFvSj0VFc5ab2gDZf6H2FCKuM",
  authDomain: "overtime-management-83008.firebaseapp.com",
  projectId: "overtime-management-83008",
  storageBucket: "overtime-management-83008.appspot.com",
  messagingSenderId: "1023865637379",
  appId: "1:1023865637379:web:7f24724c485f0bfc7b9c36",
  measurementId: "G-BC5X14V42F",
};

export const firebaseConfig2 = {
  "apiKey": "AIzaSyA1goOmx4XJ6SXCagDWYQXfQv4JeVVPCCM",
  "authDomain": "otm-staging-725a6.firebaseapp.com",
  "projectId": "otm-staging-725a6",
  "storageBucket": "otm-staging-725a6.appspot.com",
  "messagingSenderId": "515610716798",
  "appId": "1:515610716798:web:fa6251d829af1a6491062f",
  "measurementId": "G-DGWVZT6N8S"
};